import {TrustBlockContent} from '../TrustBlockContent'

export const LocalExperts = () => {
  return <TrustBlockContent prefix="localExperts" defaultText="Personal stories and insider travel tips" />
}
